import { EgAssistantConfig } from '@expertgroup/assistant';
import { environment } from '@/environments/environment';

/**
 * Asistentska konfiguracija, sastavljena iz okruženja.
 *
 * ⚠️ Prazan `assistantResource` znači ISKLJUČENO: drugi OIDC klijent se tada uopšte ne registruje, pa
 * asistent ne može slučajno stići u produkciju.
 *
 * ⚠⚠ Ovde je ranije pisalo da se okruženje tada ponaša bajt-identično kao pre. Nije bilo tačno, i cena je
 * bila visoka: `egAssistantInterceptor` i `AuthService` su i dalje injektovali sesiju, koja traži
 * `EG_ASSISTANT_CONFIG` — pa je isključeno stanje padalo na NG0201 još u inicijalizatoru, i lokalni
 * `npm start` se nije dizao. Isključenost se sada nosi kroz `injectAssistantSession()` i uslovnu
 * registraciju interceptora.
 *
 * Sve odluke koje su u ovoj konfiguraciji nosive — doslovan `resource`, `postLoginRoute` izveden iz redirect
 * adrese, isključena obnova zbog zajedničkog tajmera — žive u `@expertgroup/assistant` i zakucane su
 * njenim testovima. Ovde stoje samo vrednosti po okruženju.
 */
export const assistantConfig: EgAssistantConfig | null = environment.assistantResource
    ? {
          authority: environment.issuer,
          clientId: environment.assistantClientId,
          redirectUrl: environment.assistantRedirectUrl,
          resource: environment.assistantResource,
          baseUrl: environment.assistantBaseUrl,
          moduleKey: environment.assistantModuleKey,
          scope: environment.scope
      }
    : null;
